import { render } from "./UpsertPackageModal.vue?vue&type=template&id=460bd7b2&scoped=true"
import script from "./UpsertPackageModal.vue?vue&type=script&lang=js"
export * from "./UpsertPackageModal.vue?vue&type=script&lang=js"

import "./UpsertPackageModal.vue?vue&type=style&index=0&id=460bd7b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460bd7b2"]])

export default __exports__